import React, { Component } from 'react';
import {connect} from 'react-redux';

import { Button, Grid, IconButton, Modal } from '@material-ui/core';
import { getItemsByCommunity, delItemByCommunity } from '../../actions/itemAction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortAlphaDown, faSortAlphaUpAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import AddEditItem from './AddEditItem';

class ItemsList extends Component {
    constructor(props){
        super(props);

        this.state = {
           sortDesc: true,
           characterLimit:30,
           openItems:false,
           selectedItem:undefined,
           SweetAlertStyles: {modalStyles:{backgroundColor: '#ffffff'}, messageClass:'LAlertMessageStyles'},

        }

    }

    componentDidMount(){
        this.getItems()
    }

    componentDidUpdate(prevProps){
        if(prevProps.communityId!==this.props.communityId){
            this.setState({
                sortDesc:true
            })
        }
    }

    getItems=()=>{
        this.props.getItemsByCommunity(localStorage.getItem('communityId'), this.state.sortDesc);
    }

    handleSort=()=>{
        this.setState((prevState)=>({sortDesc:!prevState.sortDesc}), ()=>this.getItems())

    }

    handleClose=()=>{
        this.setState({openItems:false, selectedItem:undefined}, ()=>this.getItems());

    }

    handleDelete=(e, id)=>{
        this.props.delItemByCommunity(id, this.state.SweetAlertStyles? this.state.SweetAlertStyles : {})
    }

    handleEdit=(e, item)=>{
        this.setState({selectedItem:item, openItems:true})
    }


    render() {
        return (
            <>
                <Grid item container xs={12} justifyContent='center' alignContent='flex-start' className='setUpsectionContainer itemsContainer'>
                    {/* Title and button */}
                    <Grid item container xs={12} justifyContent='space-between' alignItems='center'>
                        <Grid item className='LsetUpTitle'>{`Items (${this.props.items?this.props.items.length:0})`}</Grid>

                        <Button className='Lsetup_btn' onClick={()=>this.setState({openItems:true})}>
                            Add Item
                        </Button>
                    </Grid>


                    <Grid item container xs={12} className='LRepairsOpenedHeaders' style={{paddingLeft:'20px', paddingTop:'20px'}} alignItems='center'>
                        <Grid item xs={3} lg={2}>
                            Icon
                        </Grid>
                        <Grid item container xs={9} lg={10} alignItems='center'>
                            Item Name
                            <IconButton onClick={this.handleSort}>
                                <FontAwesomeIcon icon={this.state.sortDesc? faSortAlphaDown: faSortAlphaUpAlt} color='#a2a1a2' />
                            </IconButton>
                        </Grid>
                     
                    </Grid>

                    <Grid item container xs={12}  className="roomsContainer">
                        {
                            this.props.items && this.props.items.map((item, index)=>{
                                return(
                                    <Grid item container xs={12} key={item._id} className='roomRow'
                                        style={{backgroundColor:(index%2!==0)?'white':'#fafafa'}}
                                        justifyContent='space-between' alignItems='center'
                                    >
                                        <Grid item  xs={3} lg={2} style={{paddingLeft:'20px', cursor:'pointer'}} onClick={(e)=>this.handleEdit(e,item)}>
                                            <img
                                                src={item.iconUrl}
                                                alt={`item_icon_${item._id}`}
                                                width='50px'
                                                height='50px'
                                                className='Llogo-black'
                                            />
                                        </Grid>
                                        <Grid item xs={7} lg={8} style={{paddingLeft:'10px', cursor:'pointer'}} onClick={(e)=>this.handleEdit(e,item)}>
                                            {item.name}
                                        </Grid>

                                        <IconButton onClick={(e)=>this.handleDelete(e,item._id)}>
                                            <FontAwesomeIcon icon={faTrashAlt} color='#c55e42' size='sm'/>
                                        </IconButton>
                                    </Grid>
                                )
                            })
                        }
                    </Grid>

                   


                </Grid>
                
                <Modal
                    open={this.state.openItems}
                    style={{ borderRadius: '16px' }}
                    onClose={this.handleClose}
                >
                    <AddEditItem
                        close={this.handleClose}
                        characterLimit={this.state.characterLimit}
                        data={this.state.selectedItem}
                    />
                </Modal>
            </>
        )
    }
}


function mapStateToProps(state,dispatch) {
    let items = (state.itemReducer && state.itemReducer.itemData) ? state.itemReducer.itemData : [];

    return{
        items
    }
};

export default connect(mapStateToProps,{getItemsByCommunity, delItemByCommunity})(ItemsList)

